import styled from 'styled-components'

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  .tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
`
